var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('button',_vm._g({class:[
        'base-button',
        _setup.sizeClass,
        _setup.typeClass,
        _setup.modifierClasses,
        _setup.isLabel && 'base-button-cannot-be-hovered',
        _vm.active && 'base-button-active',
    ]},_setup.listeners),[_c('span',{staticClass:"base-button-helper"}),(_vm.icon)?_c('BaseIcon',{class:_setup.iconClasses,attrs:{"name":_vm.icon}}):_vm._e(),(_vm.size !== 'icon')?_c('span',{staticClass:"base-button-main"},[_vm._t("default")],2):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }